import React from "react";

// core
import { DatePicker as DatePickerJalali } from "antd-jalali";

// components
import { Loading } from "../../components/Loading";
import { Table, Input, Button, Select, Form, Modal } from "antd";
import useProductCityStock from "./useProductCityStock";
import { Header } from "../../components/Header";
import Dragger from "antd/lib/upload/Dragger";

const { Column } = Table;
const { Option } = Select;

export const ProductCityStock = (props) => {
  const [form] = Form.useForm();
  const [
    cities,
    loading,
    productCityStocks,
    stockTypes,
    onSubmit,
    showConfirmModal,
    file,
    fileList,
    onRemove,
    beforeUpload,
    uploadExcelProducts,
    isUpLoading,
  ] = useProductCityStock();

  const getTransactionStatus = (status) => {
    switch (status) {
      case "create":
        return "ایجاد شده";

      default:
        return "";
    }
  };
  return (
    <Loading isLoading={loading}>
      <Header title="موجودی محصولات" activeItem={"productCityStocks"} />
      <div className="mb-20" style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Modal
          visible={showConfirmModal}
          footer={null}
          centered={true}
          closable={false}
          destroyOnClose={true}
        >
          {isUpLoading ? (
            <div className="text-center">
              <Loading />
              <span className="mr-10">در حال آپلود فایل، لطفا صبور باشید!</span>
            </div>
          ) : (
            <div>
              <div className="text-center">
                <div>
                  آیا آپلود فایل{" "}
                  <span className="color-promotion-s1">{file?.name}</span> برای
                  را تائید میکنید؟
                </div>
                <small className="color-orange">
                  با آپلود این فایل مشخصات کالاهای این فروشگاه تغییر میکند.
                </small>
              </div>
              <div className="flex-row flex-content-space-between mt-15">
                <Button
                  className="button-red w-45"
                  onClick={() => onRemove(null)}
                >
                  خیر
                </Button>
                <Button
                  className="button-promotion w-45"
                  onClick={uploadExcelProducts}
                >
                  بله
                </Button>
              </div>
            </div>
          )}
        </Modal>
        <Dragger
          className="border-black mt-20 "
          maxCount={1}
          accept=".xls,.xlsx"
          fileList={fileList}
          onRemove={onRemove}
          beforeUpload={beforeUpload}
          multiple={false}
        >
          <p>آپلود اکسل موجودی کالاهای جدید</p>
          <small className="color-orange">نوع فایل باید xls یا xlsx باشد</small>
        </Dragger>
        <Form
          form={form}
          name="productCityStockForm"
          initialValues={{
            product_id: "",
            city_id: null,
            start_date: null,
            end_date: null,
            stock_type: null,
          }}
          onFinish={onSubmit}
          requiredMark={false}
          scrollToFirstError
        >
          <div className="flex-row flex-content-space-between flex-wrap py-10 px-20">
            <Form.Item
              name="product_id"
              onChange={(e) => form.setFieldValue("product_id", e.target.value)}
              className="w-50 sm:w-100 my-5"
              rules={[
                {
                  required: true,
                  message: "شناسه کالا الزامی است",
                },
              ]}
              colon={false}
            >
              <Input
                className="input-black border-black mb-16"
                placeholder="شناسه کالا"
              />
            </Form.Item>
            <Form.Item
              name="city_id"
              className="w-45 sm:w-100"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "شهر الزامی است",
                },
              ]}
            >
              <Select
                className="border-black mb-16"
                showSearch
                optionFilterProp="name"
                onChange={(value) => form.setFieldValue("city_id", value)}
                placeholder={"شهر"}
              >
                <Option value={null} name="همه شهرها">
                  همه شهرها
                </Option>
                {cities.map((city) => (
                  <Option value={city.id.toString()} name={city.name}>
                    <small className="color-promotion-s1">
                      [{city.province.name}]
                    </small>{" "}
                    {city.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              className="w-50 sm:w-100"
              style={{ marginBottom: "16px" }}
              name="start_date"
              label="تاریخ شروع"
              colon={false}
            >
              <DatePickerJalali
                className="input-black border-black w-100"
                format="YYYY-MM-DD"
              />
            </Form.Item>
            <Form.Item
              className="w-45 sm:w-100"
              style={{ marginBottom: "16px" }}
              name="end_date"
              label="تاریخ پایان"
              colon={false}
            >
              <DatePickerJalali
                className="input-black border-black w-100"
                format="YYYY-MM-DD"
              />
            </Form.Item>
            <Form.Item
              className="w-50 sm:w-100"
              name="stock_type"
              label="نوع موجودی"
              colon={false}
            >
              <Select
                className="border-black"
                showSearch
                optionFilterProp="name"
                onChange={(value) => form.setFieldValue("stock_type", value)}
                disabled={!stockTypes.length}
                placeholder="موجودی ها"
              >
                <Option value={null} name="همه">
                  همه
                </Option>
                {stockTypes.map((stockType) => (
                  <Option value={stockType[0]} name={stockType[1]}>
                    {stockType[1]}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <div className="w-50 sm:w-100"></div>
            <div className="w-100 flex flex-content-center flex-items-center">
              <Button
                className={`button-secondary w-50 sm:w-100 mt-15 ${!productCityStocks?.product ? "mb-15" : ""}`}
                htmlType="submit"
              >
                فیلتر
              </Button>
            </div>
          </div>
        </Form>
        {productCityStocks?.product && <div className="flex-column flex-content-center text-center p-15 border-black mb-15">
          <div>
            <strong className="ml-8" style={{ fontSize: "22px" }}>محصول:</strong>
            <span style={{ fontSize: "18px" }}>{productCityStocks?.product?.name}</span>
          </div>
          <div><strong style={{ fontSize: "22px" }}>موجودی: </strong>
            <span style={{ fontSize: "18px" }}>{productCityStocks.total_stock_quantity}</span></div>
        </div>}
      </div>
      <Table
        size="small"
        scroll={{ x: 640 }}
        dataSource={productCityStocks?.transactions ?? []}
        pagination={false}
      //   pagination={{
      //     position: ["bottomCenter"],
      //     current: pagination.page,
      //     pageSize: pagination.limit,
      //     total: pagination.count,
      //     onChange: changePage,
      //   }}
      >
        <Column
          title="محصول"
          render={() => <span>{productCityStocks.product.name}</span>}
        />
        <Column
          title="تعداد"
          dataIndex="quantity"
          key="quantity"
          render={(quantity) => (
            <div>
              <span className="mx-10">
                {quantity < 0 ? `${Math.abs(quantity)}-` : quantity}
              </span>
            </div>
          )}
        />
        <Column
          title="وضعیت موجودی"
          dataIndex="stock_type"
          key="stock_type"
          render={(stock_type) => {
            const stock = stockTypes.find(
              (stockType) => stockType[0] === stock_type
            );
            return (
              <div>
                {stock ? <span className="mx-10">{stock[1]}</span> : null}
              </div>
            );
          }}
        />
        <Column
          title="وضعیت تراکنش"
          dataIndex="status"
          key="status"
          render={(status) => (
            <div>
              <span className="mx-10">{getTransactionStatus(status)}</span>
            </div>
          )}
        />
        <Column
          title="تاریخ ثبت تراکنش"
          dataIndex="created_at"
          key="created_at"
          render={(created_at) => (
            <div>
              <span>{created_at}</span>
            </div>
          )}
        />
      </Table>
      <div className="flex-row flex-wrap mt-10 px-20 mb-10">
        <div className="ml-40">
          <strong>موجودی انبار: </strong>
          <span>{productCityStocks.stock_quantity}</span>
        </div>
        <div>
          <strong>فروش: </strong>
          <span>{productCityStocks.order_quantity}</span>
        </div>
      </div>
    </Loading>
  );
};
